import { render } from "./UploadAssignment.vue?vue&type=template&id=d18091ca&scoped=true"
import script from "./UploadAssignment.vue?vue&type=script&lang=js"
export * from "./UploadAssignment.vue?vue&type=script&lang=js"

import "./UploadAssignment.vue?vue&type=style&index=0&id=d18091ca&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18091ca"]])

export default __exports__